import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import useEmblaCarousel from 'embla-carousel-react'
import { Image } from 'rebass'
import theme from '../../../theme'
import media from '../../../utils/style'

const SLIDE_SPACING = '12px'

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  background: ${theme.colors.blue_light};
  padding: 16px;
  width: 100%;
`

const Carousel = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  overflow: hidden;
`

const CarouselContainer = styled.div`
  display: flex;
  touch-action: pan-y;
  backface-visibility: hidden;
  margin-left: calc(${SLIDE_SPACING} * -1);
`

const CarouselSlide = styled.a`
  display: block;
  flex: 0 0 25%;
  padding-left: ${SLIDE_SPACING};
  display: flex;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  user-select: none;

  flex: 0 0 200px;

  ${media.MediumScreenUp`
    flex: 0 0 25%;
  `}

  img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 12px;
  }

  &:hover,
  &:focus {
    img {
      opacity: 0.9;
    }
  }

  img {
    transition: all 0.3s ease-in-out;
  }
`

const LESS_THAN_VIEWPORT_OPTIONS = {
  containScroll: false,
  slidesToScroll: 'auto'
}

const MORE_THAN_VIEWPORT_OPTIONS = {
  containScroll: 'trimSnaps',
  slidesToScroll: 1,
  skipSnaps: true
}

const OfferCarouselPreview = ({ items = [], handleOpen }) => {
  const [options, setOptions] = useState({ ...LESS_THAN_VIEWPORT_OPTIONS })
  const [emblaRef, emblaApi] = useEmblaCarousel(options)

  // This is required to center the slides when the viewport is smaller than the slides
  const toggleCenterSlides = useCallback((emblaApi) => {
    const { containerRect, slideRects } = emblaApi.internalEngine()
    const lastSlideRect = [...slideRects].pop()
    const slidesLessThanViewport = containerRect.right > lastSlideRect.right
    const newOptions = slidesLessThanViewport
      ? LESS_THAN_VIEWPORT_OPTIONS
      : MORE_THAN_VIEWPORT_OPTIONS

    setOptions((currentOptions) => ({ ...currentOptions, ...newOptions }))
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    emblaApi.on('reInit', toggleCenterSlides)
    toggleCenterSlides(emblaApi)
  }, [emblaApi])

  return (
    <CarouselWrapper>
      <Carousel ref={emblaRef}>
        <CarouselContainer>
          {items.map((item, index) => {
            return (
              <CarouselSlide
                key={item.title + index}
                onClick={() => handleOpen(index)}
              >
                <Image src={item.previewSrc} alt={item.title} />
              </CarouselSlide>
            )
          })}
        </CarouselContainer>
      </Carousel>
    </CarouselWrapper>
  )
}

export default OfferCarouselPreview
